var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVsCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9178 36.6857C13.9178 36.6857 12.3082 35.5258 14.2397 33.9769L18.74 29.954C18.74 29.954 20.0277 28.5996 21.3892 29.7797L62.9176 61.2122V76.2848C62.9176 76.2848 62.8975 78.6517 59.8593 78.3902L13.9178 36.6857Z",
    fill: "#2489CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6226 46.3984L13.9185 56.1272C13.9185 56.1272 12.8186 56.9452 13.9185 58.4069L18.8883 62.926C18.8883 62.926 20.0687 64.1932 21.8124 62.7517L33.1603 54.1493L24.6226 46.3984Z",
    fill: "#1070B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4109 46.4831L63.0417 31.4976L62.9143 16.5055C62.9143 16.5055 62.0759 13.2335 59.2792 14.9365L33.1562 38.7054L43.4109 46.4831Z",
    fill: "#0877B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.858 78.4077C60.9982 79.5744 62.3798 79.1922 62.3798 79.1922L77.678 71.6559C79.6363 70.3216 79.3614 68.6655 79.3614 68.6655V23.6622C79.3614 21.6843 77.3359 21.0004 77.3359 21.0004L64.0766 14.6106C61.1793 12.8204 59.2812 14.9325 59.2812 14.9325C59.2812 14.9325 61.7225 13.1758 62.9163 16.5014V76.0074C62.9163 76.4164 62.8291 76.8186 62.6548 77.1807C62.306 77.8847 61.5481 78.5418 59.7306 78.2669L59.858 78.4077Z",
    fill: "#3C99D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVsCode);
export default __webpack_public_path__ + "static/media/vs-code.07c6b159165b7e88d203df3bcebe895f.svg";
export { ForwardRef as ReactComponent };